export const breadcrumb = {
  title: 'Databases',

  database: {
    index: 'List of databases',
    import: 'Import',
    recipient: {
      create: 'Create contact',
      edit: 'Edit contact'
    }
  },
  group: {
    index: 'Groups'
  }
};
